// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export interface TransformationsOptions {
    width?: number | string;
    quality?: "best" | "good" | "eco" | "low";
}

/**
 *
 * @param url: image url
 * @param baseCloudinaryUrl: Cloudinary url domain - include slash at the end
 * @param transformations: image transformation
 */
export const getCloudinaryUrl = (
    url?: string,
    baseCloudinaryUrl?: string,
    transformations?: TransformationsOptions,
): string => {
    let options = "/f_auto";

    // if the url doesn't cloudinary or empty - send back
    if (!url || !baseCloudinaryUrl || !url.startsWith(baseCloudinaryUrl)) {
        return url || "";
    }

    const imageUrlPath = url.replace(baseCloudinaryUrl, "");

    // If this is a svg file, we need to remove f_auto option which will
    // rasterizer the vector graphic and instead use fl_sanitize to prevent
    // automatically downloading the svg instead of displaying correctly as img src.
    if (url.endsWith(".svg")) {
        options = "fl_sanitize/";
    } else {
        options = `f_auto,w_${transformations?.width || "auto"},q_auto:${transformations?.quality || "good"}/`;
    }

    return `${baseCloudinaryUrl}${options}${imageUrlPath}`;
};
